import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { MaskText } from './ui/Reveal';
import { MagneticButton } from './ui/MagneticButton';
import { brand } from '../data/site';
import { useBooking } from './BookingModal';
import { usePrefersReducedMotion } from '../hooks/useMedia';
export function ConsultationCTA() {
  const ref = useRef<HTMLElement>(null);
  const {
    openBooking
  } = useBooking();
  const reduced = usePrefersReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const shapeY = useTransform(scrollYProgress, [0, 1], ['12%', '-12%']);
  return <section ref={ref} className="relative overflow-hidden bg-[#06060A] py-24 text-white sm:py-32" aria-label="Book a consultation" data-id="element-132" data-mp="12z0boa2awskj">
      <motion.div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 h-[34rem] w-[34rem] -translate-x-1/2 rounded-full bg-brand/20 blur-[120px]" style={reduced ? undefined : {
      y: shapeY
    }} data-id="element-133" data-mp="34qdix5rqrcjr" />

      <div className="relative mx-auto w-full max-w-container px-5 text-center sm:px-8" data-id="element-134" data-mp="376n3r8v7ko29">
        <p className="label text-lav" data-id="element-135" data-mp="32civ8l6ao7z2">{brand.hours}</p>
        <h2 className="mx-auto mt-6 max-w-4xl font-display text-[10vw] font-extrabold uppercase leading-[0.88] tracking-tightest sm:text-[6.5vw]" data-id="element-136" data-mp="2xe7m6cntq1hw">
          <MaskText text="Have an Idea?|Let’s Bring It to Life." data-id="element-137" data-mp="2shh63pc0r5wh" />
        </h2>
        <p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-138" data-mp="3q23i3f5kjpdm">
          Whether you’re building a brand from scratch or giving an existing one a new direction,
          we’re ready to create something remarkable with you.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-139" data-mp="3b6nk4z1vb9by">
          <MagneticButton onClick={openBooking} cursorLabel="Let's talk" showArrow data-id="element-140" data-mp="3b8i6mhssf9i5">
            Book a Consultation
          </MagneticButton>
          <MagneticButton to="/contact" variant="outlineLight" cursorLabel="Get a quote" data-id="element-141" data-mp="1zpxh1osqqxmk">
            Request a Quote
          </MagneticButton>
        </div>
      </div>
    </section>;
}